import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import { useDateTimeFormat } from 'utils/hooks/useDateTimeFormat';
import './SnapshotLabel.css';
import { date } from '@ipfabric/utils';
import { useTimezone } from 'utils/hooks/useTimeZone';

interface Props {
  name: ReactNode;
  date: number;
  disabled?: boolean;
  error?: boolean;
  compact?: boolean;
  ellipsis?: boolean;
}

export const SnapshotLabel: FC<Props> = (props) => {
  const dateTimeFormat = useDateTimeFormat();
  const timezone = useTimezone();

  return (
    <div
      className={classNames(
        'snapshot-label',
        props.disabled && 'snapshot-label--disabled',
      )}
    >
      <div
        className={classNames(
          'snapshot-label__date',
          props.error && 'snapshot-label__date--error',
          props.compact && 'snapshot-label__value--compact',
          props.ellipsis && 'snapshot-label__value--ellipsis',
        )}
      >
        {props.name}
      </div>
      <div
        className={classNames(
          'snapshot-label__name',
          props.error && 'snapshot-label__name--error',
          props.compact && 'snapshot-label__value--compact',
          props.ellipsis && 'snapshot-label__value--ellipsis',
        )}
      >
        {date.formatUtcTimestampInTimeZone(
          props.date,
          timezone,
          dateTimeFormat,
        )}
      </div>
    </div>
  );
};
